export default "__VITE_ASSET__CM$49LwT__"